import { isValid, parseISO } from 'date-fns'

export interface ParticipantAge { unit: 'months' | 'years', count: number }

export function getParticipantAge(birthDate: string, referenceDate: Date = new Date()): ParticipantAge | null {
  if (!birthDate) {
    return null
  }

  const birth = parseISO(birthDate)

  if (!isValid(birth) || !isValid(referenceDate)) {
    return null
  }

  const years = referenceDate.getFullYear() - birth.getFullYear()
  const months = referenceDate.getMonth() - birth.getMonth()
  const days = referenceDate.getDate() - birth.getDate()
  const totalMonths = years * 12 + months + (days < 0 ? -1 : 0)

  if (totalMonths < 0) {
    return null
  }

  if (totalMonths < 12) {
    return { unit: 'months', count: totalMonths }
  }
  return { unit: 'years', count: Math.floor(totalMonths / 12) }
}
